import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ContactUsComponent } from './contact-us.component';
import { ContactListComponent } from './contact-list/contact-list.component';

@NgModule({
  declarations: [ContactUsComponent, ContactListComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ContactUsModule { }
